import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const RangeButtons = ({ filters, onFilterChange, disabled, selectedFilter }) => (
  <div className="c-input-group">
    { filters.map(item => (
      <button
        key={item}
        className={classnames(
          `c-btn c-btn--medium u-1/${filters.length}-medium-and-down medium-and-down-ph-- u-text-center c-btn--outline c-btn--active-branding`,
          { 'is-active': item === selectedFilter }
        )}
        onClick={onFilterChange(item)}
        type="button"
        disabled={disabled}
        data-automation-id={`button:timeRange:${item}`}
      >
        {item}
      </button>
    )) }
  </div>
);

RangeButtons.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedFilter: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RangeButtons.defaultProps = {
  disabled: false,
  selectedFilter: null,
};

export default RangeButtons;
